import { post } from '../index'
import config from '@/utils/config'

export default {
  login: (authorizationBody) => post('oauth/token', authorizationBody, { auth: { username: config.oauth.username, password: config.oauth.password } })
}
